<div id="add-videos-dialog" class="{{theme}}">
    <div mat-dialog-title>
        <div class="row">
            <div *ngIf="!content.contentId" class="col-md-10">
                <h3>Add Videos</h3>
            </div>
            <div *ngIf="content.contentId" class="col-md-10">
                <h3>Edit Resources</h3>
            </div>
            <div class="col-md-2">
                <span class="fa fa-close action-icons float-right ml-auto" (click)="close()"></span>
            </div>
        </div>
    </div>
    <div mat-dialog-content>
        <form class="video-form">
            <mat-form-field class="col-md-10">
                <mat-label>Division</mat-label>
                <input matInput disabled name="division" [(ngModel)]="division" placeholder="Division" value="Toyota">
            </mat-form-field>
            <p class="col-md-10">
                <mat-label>Content Type</mat-label>&nbsp;&nbsp;
                <mat-button-toggle-group class="toggle-group" required name="contentType" #contentType=ngModel [(ngModel)]="content.featureType"
                    appearance="legacy" name="fontStyle" aria-label="Font Style">
                    <mat-button-toggle value="internal">Internal</mat-button-toggle>
                    <mat-button-toggle value="external">External</mat-button-toggle>
                    <mat-button-toggle value="both">Both</mat-button-toggle>
                </mat-button-toggle-group>
                <mat-error *ngIf="isSubmit && contentType.invalid">
                    <div *ngIf="contentType.errors.required">Content Type is required</div>
                </mat-error>
            </p>
            <mat-form-field class="col-md-10">
                <mat-label>Video Name</mat-label>
                <input matInput required autocomplete="off" name="videoName" #videoName=ngModel [(ngModel)]="content.videos.videoName" placeholder="Video Name">
                <mat-error *ngIf="isSubmit && videoName.invalid">
                    <div *ngIf="videoName.errors.required">Video Name is required</div>
                </mat-error>
            </mat-form-field>
            <mat-form-field class="col-md-10">
                <mat-label>Video Description</mat-label>
                <textarea matInput autocomplete="off" name="description" #videoName=ngModel [(ngModel)]="content.videos.description" placeholder="Video Description">
                 </textarea>   
            </mat-form-field>
            <mat-form-field class="col-md-10">
                <mat-label>Video Link</mat-label>
                <input matInput required autocomplete="off" name="videoUrl" #videoUrl=ngModel [(ngModel)]="content.videos.videoUrl" placeholder="Video Link">
                <mat-error *ngIf="isSubmit && videoUrl.invalid">
                    <div *ngIf="videoUrl.errors.required">Video Link is required</div>
                </mat-error>
            </mat-form-field>
            <mat-form-field class="col-md-10">
                <mat-label>Video Group</mat-label>
                <input matInput required name="videoGroup" #videoGroup=ngModel [matAutocomplete]="auto" [(ngModel)]="content.videos.videoGroup"
                    placeholder="Video Group">
                <mat-autocomplete #auto="matAutocomplete">
                    <mat-option *ngFor="let group of Groups" [value]="group">
                        {{group}}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="isSubmit && videoGroup.invalid">
                    <div *ngIf="videoGroup.errors.required">Video Group is required</div>
                </mat-error>
            </mat-form-field>
            <mat-form-field class="col-md-10">
                <mat-label>Search Keywords</mat-label>
                <textarea matInput autocomplete="off" name="searchKeywords" #videoName=ngModel [(ngModel)]="content.videos.searchKeywords" placeholder="Search Keywords">
                 </textarea>   
            </mat-form-field>

        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <span>
            <button class="btn btn-default" (click)="onSelect()">Save</button>
        </span>
        <span class="ml-2">
            <button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
        </span>
    </div>
</div>